import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-copy",
  "use": "svg_i-copy-usage",
  "viewBox": "0 0 11 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 13\" id=\"svg_i-copy\"><g fill=\"currentColor\" fill-rule=\"evenodd\"><path d=\"M3.46 8.948h6.184V1.099H3.459v7.849zm6.733 1.099H2.91a.55.55 0 0 1-.55-.55V.549c0-.304.246-.549.55-.549h7.284a.55.55 0 0 1 .55.55v8.947a.55.55 0 0 1-.55.55z\" /><path d=\"M7.835 12.416H.55a.55.55 0 0 1-.55-.55V2.918h1.1v8.398h6.735v1.1z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol